import { render, staticRenderFns } from "./DimensionFilter.vue?vue&type=template&id=581a9ed4&scoped=true"
import script from "./DimensionFilter.vue?vue&type=script&lang=js"
export * from "./DimensionFilter.vue?vue&type=script&lang=js"
import style0 from "./DimensionFilter.vue?vue&type=style&index=0&id=581a9ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a9ed4",
  null
  
)

export default component.exports